import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Button from '../components/Button';
import api from '../services/api';

const RegisterPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    password2: '',
  });

  const { name, email, password, password2 } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== password2) {
      toast.error('Hasła nie są zgodne!');
    } else {
      try {
        await api.post('/auth/register', { name, email, password });
        toast.success('Rejestracja pomyślna! Możesz się teraz zalogować.');
        navigate('/login');
      } catch (err) {
        toast.error(err.response?.data?.message || 'Wystąpił błąd');
        console.error(err.response.data);
      }
    }
  };

  return (
    <div className="flex justify-center items-center">
      <div className="w-full max-w-md p-8 space-y-8 bg-gray-800 rounded-lg shadow-lg">
        <h2 className="text-3xl font-bold text-center text-white">Rejestracja</h2>
        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="name"
              className="block mb-2 text-sm font-medium text-gray-300"
            >
              Nazwa użytkownika
            </label>
            <input
              type="text"
              name="name"
              value={name}
              onChange={onChange}
              required
              className="input"
            />
          </div>
          <div>
            <label
              htmlFor="email"
              className="block mb-2 text-sm font-medium text-gray-300"
            >
              Email
            </label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={onChange}
              required
              className="input"
            />
          </div>
          <div>
            <label
              htmlFor="password"
              className="block mb-2 text-sm font-medium text-gray-300"
            >
              Hasło
            </label>
            <input
              type="password"
              name="password"
              value={password}
              onChange={onChange}
              required
              className="input"
            />
          </div>
          <div>
            <label
              htmlFor="password2"
              className="block mb-2 text-sm font-medium text-gray-300"
            >
              Potwierdź hasło
            </label>
            <input
              type="password"
              name="password2"
              value={password2}
              onChange={onChange}
              required
              className="input"
            />
          </div>
          <Button type="submit" variant="primary" className="w-full">
            Zarejestruj się
          </Button>
        </form>
        <p className="text-sm text-center text-gray-400">
          Masz już konto?{' '}
          <Link to="/login" className="font-medium text-blue-400 hover:underline">
            Zaloguj się
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;